import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import DuelScene from "./components/DuelScene";
import BonusesSection from "./components/BonusesSection";
import { LeaderboardTeaser, KickSection, SocialsSection } from "./components/HomeSections";
import Footer from "./components/Footer";
import LeaderboardPage from "./components/LeaderboardPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => (
  <main>
    <Hero />
    <DuelScene />
    <BonusesSection />
    <LeaderboardTeaser />
    <KickSection />
    <SocialsSection />
  </main>
);

function App() {
  return (
    <div className="App bg-[#171b26] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
